const t = "25.11.1", a = {
  version: t
}, o = (s) => `https://static.cdnaffs.com/my/static/libs/affstore-ui-kit/v${a.version}/flags/flags/${s.toLowerCase()}.svg`;
export {
  o as getFlagsPath
};
//# sourceMappingURL=affstore-ds-flags.js.map
